import { render, staticRenderFns } from "./AxeThrow.vue?vue&type=template&id=67706d70&scoped=true"
import script from "./AxeThrow.vue?vue&type=script&lang=js"
export * from "./AxeThrow.vue?vue&type=script&lang=js"
import style0 from "./AxeThrow.vue?vue&type=style&index=0&id=67706d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67706d70",
  null
  
)

export default component.exports